import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface GuruMatchEntry {
  id: string;
  tipo: 'AUTO' | 'MANUAL' | 'GLOBAL';
  frecuencia: string;
  candidatoId: number;
  candidatoNombre: string;
  candidatoCorreo: string;
  scrapedJobId: string;
  jobTitulo: string;
  jobEmpresa: string;
  jobModalidad: string;
  rawScore?: number;
  llmScore: number;
  justification?: string;
  suggestion?: string;
  canal: string;
  fecha: string;
}

export interface GuruMatchStats { auto: number; manual: number; global: number; }

export interface AlertaUsuario {
  candidatoId: number;
  nombre: string;
  correo: string;
  plan: 'PREMIUM' | 'FREE';
  frecuencia: string;
  tieneCvActivo: boolean;
  alertsSent: number;
  quotaMax: number | string;
  quotaRestante: number;
  canal: 'WHATSAPP' | 'EMAIL';
}

@Injectable({ providedIn: 'root' })
export class AdminGuruMatchService {
  private base = environment.baseApi + '/admin/gurumatch';
  constructor(private http: HttpClient) {}
  historial(page = 0, size = 50, tipo = '', buscar = ''): Observable<any> {
    let p = new HttpParams().set('page', page).set('size', size).set('tipo', tipo).set('buscar', buscar);
    return this.http.get(this.base + '/historial', { params: p });
  }
  stats(): Observable<GuruMatchStats> { return this.http.get<GuruMatchStats>(this.base + '/stats'); }
  diagnostico(): Observable<any> { return this.http.get(this.base + '/diagnostico'); }
  ejecutarAlertas(): Observable<any> { return this.http.post(this.base + '/ejecutar', {}); }
  alertStatus(): Observable<any>  { return this.http.get(this.base + '/status'); }
  usuarios(page = 0, size = 50, buscar = '', frecuencia = '', plan = ''): Observable<any> {
    let p = new HttpParams().set('page', page).set('size', size).set('buscar', buscar).set('frecuencia', frecuencia).set('plan', plan);
    return this.http.get(this.base + '/usuarios', { params: p });
  }
}
